import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

export const SMSStroke = (props: IIconProps) => {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.933 4C3.783 4 2 5.694 2 7.833v7.112c0 2.14 1.784 3.833 3.933 3.833h.5c.19 0 .332.152.33.323-.016 1.488 1.657 2.347 2.868 1.518l2.242-1.535c.291-.2.638-.306.993-.306h4.21c2.149 0 3.933-1.694 3.933-3.833V7.833c0-2.14-1.784-3.833-3.934-3.833H5.933ZM3.5 7.833C3.5 6.567 4.567 5.5 5.933 5.5h11.142c1.367 0 2.434 1.067 2.434 2.333v7.112c0 1.266-1.067 2.333-2.434 2.333h-4.21c-.656 0-1.298.198-1.839.568l-2.243 1.535a.33.33 0 0 1-.52-.264 1.825 1.825 0 0 0-1.83-1.84h-.5c-1.366 0-2.433-1.066-2.433-2.332V7.833Zm3.136.567a.747.747 0 0 0-.75.743c0 .411.335.744.75.744h3.769c.414 0 .75-.333.75-.744a.747.747 0 0 0-.75-.743h-3.77Zm0 2.973a.747.747 0 0 0-.75.744c0 .41.335.743.75.743h9.038c.415 0 .751-.333.751-.743a.747.747 0 0 0-.75-.744h-9.04Z"
        fill="currentColor"
      />
    </Icon>
  );
};

export default SMSStroke;
